import {
  Route, Routes as ReactRoutes, Navigate
} from "react-router-dom";
import { Auth } from "aws-amplify";
import ChangeAuthenticator from "domains/ChangeAuthenticator/ChangeAuthenticator";
import Unauthorised from "domains/Misc/Unauthorised";
import Unknown from "domains/Misc/Unknown";

const logout = async () => {
  try {
    Auth.currentAuthenticatedUser().then(async user => {
      Auth.signOut().then(reason => {
        window.location.href = "/";
      });
    });
  } catch (error) {
    // console.log("error signing out: ", error);
  }
};

const HandleLogoutComponent = () => {
  logout();
  return <></>;
};
const Routes = () => (
  <ReactRoutes>
    <Route path="/" element={<Navigate replace to="/changeauthenticator" />} />
    <Route path="/changeauthenticator" element={<ChangeAuthenticator />} />
    <Route path="/unauthorised" element={<Unauthorised />} />
    <Route path="/logout" element={<HandleLogoutComponent />} />
    <Route path="*" element={<Unknown />} />
  </ReactRoutes>
);

export default Routes;
